import React, { useState, useEffect } from "react";
import { Mail, Send, Info } from "lucide-react";

const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:3005";

const ContactComponent = ({ isOpen = true, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
    }
  }, [isOpen]);

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const sendContactMessage = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${baseUrl}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nombre: formData.name,
          email: formData.email,
          asunto: formData.subject,
          mensaje: formData.message,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.message || "Error al enviar el mensaje");
        return;
      }

      alert("Mensaje enviado correctamente. Te contactaremos pronto.");
      onClose && onClose();
    } catch (error) {
      console.error("Error enviando mensaje:", error);
      alert("Error al enviar el mensaje");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      alert("Por favor, completa todos los campos obligatorios.");
      return;
    }

    sendContactMessage();
  };

  if (!isOpen) return null;

  return (
    <div
      className="dyd-page"
      style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "24px" }}
    >
      <div
        className="dyd-modal"
        style={{ maxHeight: "none" }}
      >
        <div className="dyd-modal-head">
          <span className="dyd-modal-icon"><Mail size={20} /></span>
          <div>
            <h2>Contacto</h2>
            <p style={{ margin: 0, fontSize: "0.88rem" }}>
              ¿Tienes alguna duda o propuesta? Escríbenos.
            </p>
          </div>
        </div>

        <div className="dyd-field">
          <label className="dyd-label">
            Nombre *
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={handleChange("name")}
            placeholder="Tu nombre"
            className="dyd-input"
          />
        </div>

        <div className="dyd-field">
          <label className="dyd-label">
            Email *
          </label>
          <input
            type="email"
            value={formData.email}
            onChange={handleChange("email")}
            placeholder="tu@email.com"
            className="dyd-input"
          />
        </div>

        <div className="dyd-field">
          <label className="dyd-label">
            Asunto *
          </label>
          <input
            type="text"
            value={formData.subject}
            onChange={handleChange("subject")}
            placeholder="Motivo del contacto"
            className="dyd-input"
          />
        </div>

        <div className="dyd-field">
          <label className="dyd-label">
            Mensaje *
          </label>
          <textarea
            value={formData.message}
            onChange={handleChange("message")}
            placeholder="Escribe tu mensaje aquí..."
            rows={4}
className="dyd-textarea"
          />
        </div>

        <div
          className="dyd-note"
        >
          <Info size={16} />
          <small>Te responderemos lo antes posible al email proporcionado.</small>
        </div>

        <div className="dyd-modal-actions">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="dyd-btn dyd-btn-primary"
          >
            <Send size={16} />
            {loading ? "Enviando…" : "Enviar mensaje"}
          </button>

          {onClose && (
            <button
              onClick={onClose}
className="dyd-btn dyd-btn-subtle"
            >
              Cancelar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};


export default ContactComponent;
